export const partnerBasicInfoTranslation = {
  notification: {
    affiliateWithMandatoryContactHpRoles:
      'partnerinfo-notification-affiliate_with_mandatory_contact_hp_roles',
    resellerOnlineWithMandatoryContactHpRoles:
      'partnerinfo-notification-reseller_online_with_mandatory_contact_hp_roles',
    hasMatchingAddresses: 'partnerinfo-notification-has_matching_addresses',
  },
  content: {
    validation: {
      attachments: 'partnerinfo-content-validation-attachments',
    },
    blockTitles: {
      hierarchyBlock: 'partnerinfo-content-blocktitles-hierarchy_block',
      commonBlock: 'partnerinfo-content-blocktitles-common_block',
      addressBlock: 'partnerinfo-content-blocktitles-address_block',
    },
  },
  confirm: {
    affiliateAvailibility: {
      title: 'partnerinfo-confirm-affiliate_availibility-title',
      content: 'partnerinfo-confirm-affiliate_availibility-content',
      confirm: 'partnerinfo-confirm-affiliate_availibility-confirm',
    },
    resellerNetworkAvailability: {
      title: 'partnerinfo-confirm-reseller-network_availability-title',
      content: 'partnerinfo-confirm-reseller-network_availability-content',
      confirm: 'partnerinfo-confirm-reseller-network_availability-confirm',
    },
  },
}
